import { Expose } from 'class-transformer'

export class PenNameType {
  @Expose() id: number

  @Expose() firstPenName: string

  @Expose() secondPenName: string
}
